import {Bond} from "../models/Bond";

class StatUtil {
    static calculateYTMfromBond(bond: Bond, price: number | undefined): number {
        // @ts-ignore
        if (price === undefined || price <= 0) {
            return 0.0;
        }
        // @ts-ignore
        const expiryDate = new Date(bond.genInfo.expiry);
        const now = new Date();
        const yearsToMaturity = (expiryDate.getTime() - now.getTime()) / (1000 * 3600 * 24 * 365.25);
        if (yearsToMaturity <= 0) {
            return 0.0;
        }
        return this.calculateYTM(
            price,
            // @ts-ignore
            bond.genInfo.face_value || 100,
            // @ts-ignore
            bond.genInfo.coupon,
            yearsToMaturity
        );
    }

    static calculateYTM(
        marketPrice: number,
        faceValue: number,
        couponRatePercent: number,
        yearsToMaturity: number,
        paymentsPerYear: number = 2,
        guess: number = 0.1
    ): number {
        let ytm = guess;
        const maxIterations = 100;
        const tolerance = 1e-8;

        for (let i = 0; i < maxIterations; i++) {
            const price = this.calculateBondPrice(
                faceValue,
                couponRatePercent,
                ytm * 100,  // our price function expects % input
                yearsToMaturity,
                paymentsPerYear,
            );

            const diff = marketPrice - price;
            if (Math.abs(diff) < tolerance) break;

            // numerical derivative (finite difference)
            const priceUp = this.calculateBondPrice(
                faceValue,
                couponRatePercent,
                (ytm + 1e-5) * 100,
                yearsToMaturity,
                paymentsPerYear,
            );
            const derivative = (priceUp - price) / 1e-5;

            ytm += diff / derivative;
        }

        return ytm * 100;  // return annualized % YTM
    }

    static calculateBondPrice(
        faceValue: number,
        couponRatePercent: number,
        ytmPercent: number,
        yearsToMaturity: number,
        paymentsPerYear: number = 1
    ): number {
        const ytm = ytmPercent / 100.0 / paymentsPerYear;
        const totalPeriods = Math.trunc(yearsToMaturity * paymentsPerYear);
        const coupon = (couponRatePercent / 100.0) * faceValue / paymentsPerYear;

        let price = 0.0;
        for (let t = 1; t <= totalPeriods; t++) {
            price += coupon / Math.pow(1 + ytm, t);
        }

        // Handle fractional last period if maturity is not exact
        const fractionalPeriods = yearsToMaturity * paymentsPerYear - totalPeriods;
        if (fractionalPeriods > 0) {
            const fractionalTime = totalPeriods + fractionalPeriods;
            price += (coupon + faceValue) / Math.pow(1 + ytm, fractionalTime);
//        price += (coupon * fractionalPeriods) / Math.pow(1 + ytm, fractionalTime)
//        price += faceValue / (1 + ytm).pow(fractionalTime)
        } else {
            price += faceValue / Math.pow(1 + ytm, totalPeriods);
        }

        return price;
    }
}


export default StatUtil;
